import React from "react";
import icon_close from "../../assets/icons/icon-close.svg";
import Modal from "react-modal";
import { useSubscriptionContext } from "../../context/providers/SubscriptionContext";
const CancelSubscription = ({ activeModal, closeModal, modalStylesReset, subscription }) => {
	const { cancelSubscription } = useSubscriptionContext();
	const handleClick = (e) => {
		cancelSubscription(subscription._id);
		closeModal();
	};
	return (
		<Modal isOpen={activeModal === "CancelSubscription"} onRequestClose={closeModal} style={modalStylesReset}>
			<div className="modal__content container--default d-flex flex-column justify-content-center p-3 p-md-4">
				<button className="btn btn--white modal__close p-4" onClick={closeModal}>
					<img src={icon_close} alt="" />
				</button>
				<div className="text-center">
					<h2 className="modal__title">Cancel your subscription?</h2>
					<p className="mt-3">You will have access to educational materials until the end of the paid period</p>
					<div className="d-flex flex-column align-items-center justify-content-center">
						<button className="btn btn--primary w-100 mt-5" onClick={closeModal}>
							No, keep me subscribed
						</button>
						<button className="btn btn--cancel w-100 mt-3" onClick={handleClick}>
							Yes, cancel my subscription
						</button>
					</div>
				</div>
			</div>
		</Modal>
	);
};

export default CancelSubscription;
